import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check-circled",
  "use": "check-circled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check-circled\"><circle cx=\"11.5\" cy=\"11.5\" r=\"9\" stroke-linecap=\"round\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" /><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M16.5 8.5L10.13 15 7 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol